export default "__VITE_ASSET__4AM$0CRc__"